import { StandardEvents } from '@shopify/events';

class FtBarrelProductionFacts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const pending = event.promise;
      if (!pending?.then) return;
      this.pending = pending;
      pending.then(({ detail }) => {
        if (!this.isConnected || this.pending !== pending || !detail?.html) return;
        if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
        const source = detail.html.querySelector('ft-barrel-facts');
        if (source?.dataset.productId === this.dataset.productId) {
          this.replaceChildren(...Array.from(source.childNodes, node => document.importNode(node, true)));
          this.hidden = false;
          this.style.removeProperty('display');
        } else {
          // Response without a valid facts box: never keep facts of a previous variant visible.
          this.replaceChildren();
          this.hidden = true;
          this.style.display = 'none';
        }
      }).catch(() => {});
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('ft-barrel-facts')) customElements.define('ft-barrel-facts', FtBarrelProductionFacts);
